import AdminAsanaSettings from './AdminAsanaSettings';

export default AdminAsanaSettings;
